<header class="fund-list--header">
    <h3 *ngIf="header" class="topic-title">
        <span id="fund-cate-icon" rel="border-circle" class="">
            <img src="assets/images/icon/filter/icon-etf-white.png" />
        </span>
        <span class="text" id="fund-cate-name">{{header}}</span>
    </h3>
</header>
<div *ngIf="description" class="fund-list--detail" id="fund-cate-detail">
    {{description}}
</div>
<!-- <footer class="fund-list--section-follow">
  <span class="text">ติดตามมูลค่าหน่วยลงทุนกองทุนง่ายๆ แค่กด</span>
  <app-favorite-button [disabled]="true"></app-favorite-button>
</footer> -->

<div class="fund-list--suggesstion">
    <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
            <div class="fund-list--wrapper">
                <header>
                    <span>{{language.fundlisttitle1}}</span>
                    <span>{{language.fundlisttitle2}}</span>
                </header>
                <div class="d-none d-sm-none d-md-none d-lg-block d-xl-block">
                    <ng-container *ngFor="let fundItem of fundList; let fundIndex = index">
                        <div *ngIf="flag == 'th'; else elsefundList1">
                            <app-fund-list-item *ngIf="fundIndex % 2 === 0" [type]="fundItem.type"
                                [riskLevel]="fundItem.riskLevel+fundItem.riskLevelSpecial" [title]="fundItem.title" [fundid]="fundItem.fundid"
                                [Currency]="fundItem.currency" [description]="fundItem.description"
                                [recommended]="fundItem.recommended">
                            </app-fund-list-item>
                        </div>
                        <ng-template #elsefundList1>
                            <app-fund-list-item *ngIf="fundIndex % 2 === 0" [type]="fundItem.type"
                                [riskLevel]="fundItem.riskLevel+fundItem.riskLevelSpecial" [title]="fundItem.title" [fundid]="fundItem.fundid"
                                [Currency]="fundItem.currency" [description]="fundItem.description_en"
                                [recommended]="fundItem.recommended">
                            </app-fund-list-item>
                        </ng-template>
                    </ng-container>
                </div>

                <div class="d-block d-sm-block d-md-block d-lg-none d-xl-none ">
                    <ng-container *ngFor="let fundItem of fundList; let fundIndex = index">
                        <div *ngIf="flag == 'th'; else elsefundList2">
                            <app-fund-list-item [type]="fundItem.type" [riskLevel]="fundItem.riskLevel+fundItem.riskLevelSpecial"
                                [title]="fundItem.title" [fundid]="fundItem.fundid" [Currency]="fundItem.currency"
                                [description]="fundItem.description" [recommended]="fundItem.recommended">
                            </app-fund-list-item>
                        </div>
                        <ng-template #elsefundList2>
                            <app-fund-list-item [type]="fundItem.type" [riskLevel]="fundItem.riskLevel+fundItem.riskLevelSpecial"
                                [title]="fundItem.title" [fundid]="fundItem.fundid" [Currency]="fundItem.currency"
                                [description]="fundItem.description_en" [recommended]="fundItem.recommended">
                            </app-fund-list-item>
                        </ng-template>
                    </ng-container>
                </div>

            </div>
        </div>
        <div class="d-none d-sm-none d-md-none d-lg-block d-xl-block col-lg-6 col-xl-6">
            <div class="fund-list--wrapper">
                <header class="header--secondary">
                    <span>{{language.fundlisttitle1}}</span>
                    <span>{{language.fundlisttitle2}}</span>
                </header>
                <ng-container *ngFor="let fundItem of fundList; let fundIndex = index">
                    <div *ngIf="flag == 'th'; else elsefundList3">
                        <app-fund-list-item *ngIf="fundIndex % 2 !== 0" [type]="fundItem.type"
                            [riskLevel]="fundItem.riskLevel+fundItem.riskLevelSpecial" [title]="fundItem.title" [fundid]="fundItem.fundid"
                            [Currency]="fundItem.currency" [description]="fundItem.description"
                            [recommended]="fundItem.recommended"></app-fund-list-item>
                    </div>
                    <ng-template #elsefundList3>
                        <app-fund-list-item *ngIf="fundIndex % 2 !== 0" [type]="fundItem.type"
                            [riskLevel]="fundItem.riskLevel+fundItem.riskLevelSpecial" [title]="fundItem.title" [fundid]="fundItem.fundid"
                            [Currency]="fundItem.currency" [description]="fundItem.description_en"
                            [recommended]="fundItem.recommended"></app-fund-list-item>
                    </ng-template>
                </ng-container>
            </div>
        </div>
        <div class="col-12">
            <div class="fund-list--suggesstion">
                <span class="recommend-mask">
                    <i class="fas fa-star"></i>
                </span>
                <span>{{language.menu2box5}}</span>
            </div>
        </div>
        <div class="col-12">
            <div class="fund-list--paginator">
                <app-paginator [currentPage]="currentPage" [totalPage]="totalPage"
                    (currentPageNumber)="setCurrentPage($event)">
                </app-paginator>
            </div>
        </div>
    </div>
</div>